import { ContactEmail } from 'starbase-launcher';
import { ColumnDataTypes, ITableColumn, TableColumn } from 'new-table-editor';

// eslint-disable-next-line @typescript-eslint/naming-convention
export class ContactEmail_ext extends ContactEmail {
  public static ContactEmailColumns(): ITableColumn[] {
    const emCol: TableColumn = new TableColumn(
      'emailAddress',
      'Email',
      ColumnDataTypes.email,
      true,
      true,
      true);
    emCol.minLength = 5;
    emCol.allowSort = true;
    emCol.placeholder = 'user@abc.xyz';
    emCol.editableNew = true;
    emCol.tooltip = 'Email Address';

    const emDesc = new TableColumn('description', 'Description', ColumnDataTypes.string);
    const preferredCol = new TableColumn('preferred', '', ColumnDataTypes.yesno, false, true, false);
    preferredCol.iconClass = 'fa-check';
    preferredCol.allowSort = false;
    preferredCol.tooltip = 'Preferred';
    preferredCol.textAlignment = 'center';

    return [
      emCol,
      emDesc,
      preferredCol,
      {
        columnName: 'contactUID', displayName: 'Contact UID',
        dataType: ColumnDataTypes.number, visible: false, required: false, editable: false, colloquial: false, editableNew: true
      }, // actually required but added in the data service when POSTing
      ...TableColumn.generateColumnsForStarbaseEntity()
    ];

  }
}
